<template>
  <div>
      <a-row>
        <a-tabs defaultActiveKey="1" @change="callback">
            <a-tab-pane key="1">
              <span slot="tab">
                <a-icon type="safety-certificate" />
                Seguridad social
              </span>
            <a-card>
            <g-master name="forms"
                      :endpoint="master.endpoint"
                      :tableSetup="master.tableSetup"
                      :modalFieldsSetup="master.modalFieldsSetup"
                      :parentData="parentData"
                      @action="masterAction"
                      modalWidth="80%"
                      ref="master"
            >
              <template slot="masterModal" slot-scope="{record}">
                <a-row :gutter="[16,16]">
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Tipo de entidad')"
                                :formItemConfig="fiOptions"
                                :decorator="['ent_type', { rules: [{ required: false}] }]"
                                :params="tipo_entidad"
                                :selectedObj.sync="tipoEntidadSeleccionada"
                                ref="tentidad"
                    >
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown v-bind="fiOptions"
                                endpoint="ent_type"
                                :label="$t('Entidad')"
                                :formItemConfig="fiOptions"
                                :params="entidadSeleccionada"
                                :selectedObj.sync="id_tipo_entidad"
                                :decorator="['ent_id', { rules: [{ required: false}] }]"
                                ref="entidad"
                    >
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="ent_type"
                                :label="$t('Última entidad')"
                                :formItemConfig="fiOptions"
                                :params="entidadSeleccionada"
                                :decorator="['ent_id_last', { rules: [{ required: false}] }]"
                    >
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('Fecha desde')">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD HH:mm:ss"
                                     v-decorator="['since_date', { rules: [{ required: false, message: 'Valor requerido'}], initialValue: initial_date  }]"
                      ></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown v-if="tipoEntidadArl"
                                endpoint="hierarchy_lookup"
                                :label="$t('Cobertura')"
                                :formItemConfig="fiOptions"
                                :params="riesgo_arl"
                                :decorator="['cob', { rules: [{ required: true,  message: 'Valor requerido'}] }]"
                    >
                    </g-dropdown>
                    <a-form-item v-else :label="$t('Cobertura')">
                      <a-input
                        v-decorator="['cob', { rules: [{ required: false}] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Nov SS')">
                      <a-input
                        v-decorator="['nov_ss', { rules: [{ required: false}] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Año')" v-bind="fiOptions">
                      <a-select v-decorator="['year', { rules: [
                            { required: false, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                        <a-select-option v-for="year_ in years" :key="year_">
                          {{ year_ }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                      <a-select v-decorator="['month', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                        <a-select-option v-for="month_ in months_name" :key="month_.value">
                          {{ month_.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('% Empleado')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['percent_emp', { rules: [{ required: false }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item v-bind="fiOptions" :label="$t('% Company')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['percent_company', { rules: [{ required: false }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </template>
            </g-master>
            </a-card>
          </a-tab-pane>
          <a-tab-pane key="2">
            <span slot="tab">
              <a-icon type="clock-circle" />
              Histórico
            </span>
            <a-card>
              <employee-social-security-hist ref="historial"
                                             :empleadoseleccionado="empleadoseleccionado"></employee-social-security-hist>
            </a-card>
          </a-tab-pane>
        </a-tabs>
      </a-row>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['empleadoseleccionado', 'isHumanManagement', 'initial_date'],
    mounted () {
      this.yearsSelect()
      if (this.isHumanManagement) {
        this.master.tableSetup.actions.actions.push({
          name: 'masterEdit',
          text: 'Editar',
          permisos: [],
          fnVisible: () => !this.$userIsInrol('Query'),
          props: {size: 'small', type: 'link', icon: 'edit'}
        })
      }
    },
    data () {
      return {
        yearToday: parseInt(moment().format('YYYY')),
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        years: [],
        id_tipo_entidad: {},
        tipoEntidadSeleccionada: {},
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        tipo_entidad: {
          h_lookup_type: 'TIPO_ENTIDAD',
          use_code: true
        },
        riesgo_arl: {
          h_lookup_type: 'RIESGO_ARL',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'social_security',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Tipo de entidad', dataIndex: 'ent_type_desc', sorter: true},
              {title: 'ID entidad', dataIndex: 'ent_id_name', sorter: true},
              {title: 'Cobertura', dataIndex: 'cob', sorter: true},
              {title: '% Empleado', dataIndex: 'percent_emp', sorter: true},
              {title: '% Compañía', dataIndex: 'percent_company', sorter: true},
              {title: 'Fecha desde', dataIndex: 'since_date_desc', sorter: true},
              {title: 'Nov SS', dataIndex: 'nov_ss', sorter: true},
              {title: 'Última entidad', dataIndex: 'ent_id_name_last', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ],
            actions: {
              actions: [
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  fnVisible: () => !this.$userIsInrol('Query'),
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            }
          },
          modalFieldsSetup: [
            {name: 'ent_type'},
            {name: 'ent_id'},
            {name: 'ent_id_last'},
            {name: 'since_date'},
            {name: 'cob'},
            {name: 'nov_ss'},
            {name: 'year'},
            {name: 'month'},
            {name: 'percent_emp'},
            {name: 'percent_company'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.tipoEntidadSeleccionada = {}
            break
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.ent_type)) {
              this.$refs.tentidad && this.$refs.tentidad.handleChange(action.record.ent_type)
            }
            setTimeout(() => {
              this.$refs.entidad && this.$refs.entidad.handleChange(action.record.ent_id)
            }, 500)
            break
        }
      },
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      },
      callback (key) {
        if (key === '2') {
          setTimeout(() => {
            this.$refs.historial.consultarDatos()
          }, 300)
        }
      }
    },
    computed: {
      entidadSeleccionada () {
        if (!JsUtils.isEmpty(this.tipoEntidadSeleccionada.value) && !JsUtils.isEmpty(this.tipoEntidadSeleccionada)) {
          return {
            ent_type: this.tipoEntidadSeleccionada.value,
            use_ent_id: true
          }
        } else {
          return {
            id_emp: -1
          }
        }
      },
      tipoEntidadArl () {
        return ['ARL', 'ARP'].includes(this.tipoEntidadSeleccionada.value)
      },
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeSocialSecurity.vue